import React, {useState, useEffect} from 'react';
import {Table, Input, List, Button, message, Spin} from 'antd';
import history from "../../../libs/history";
import styles from './layout.module.less'

import store from "./store";
import addressStore from "../info/address/store"
import {observer} from 'mobx-react';
import NumberInput from "../../../components/NumberInput";
import {toJS} from "mobx";

// the hook
import {useTranslation} from 'react-i18next';

const {TextArea} = Input;

export default observer(function () {
  const {t, i18n} = useTranslation()
  const {goods, orders, orderIndex, addressId} = store

  const [loading, setLoading] = useState(false)

  if (orderIndex === -1) {
    message.warn(t('请选择要发货的订单') + '！')
    history.push('/user/order')
    return
  }

  useEffect(() => {
    addressStore.addresses.length > 0 ? filterAddress() : addressStore.fetchAddresses().then(filterAddress)
  }, [])

  const columns = [
    {
      title: '',
      dataIndex: 'type',
      className: 'pl0',
      width: 35,
      fixed: true,
      render: val => <div
        className={[styles.badge, val * 1 !== 1 ? styles.badgeGhost : '', i18n.language === 'en' ? styles.autoWidth : ''].join(' ')}>
        {val * 1 === 1 ? t('购') : t('租')}
      </div>,
    },
    {
      title: t('品牌'),
      dataIndex: 'brand',
      align: 'center',
      fixed: true,
      width: 90,
    },
    {
      title: t('产品品名'),
      dataIndex: 'name',
      align: 'center',
      fixed: true,
      width: 130,
    },
    {
      title: t('货号'),
      dataIndex: 'factory_code',
      align: 'center',
      fixed: true,
      width: 90,
    },
    {
      title: t('规格'),
      dataIndex: 'formats',
      align: 'center',
      width: 50,
      fixed: true,
    },
    {
      title: t('单价'),
      dataIndex: 'price',
      align: 'center',
      fixed: true,
      render: (val, record) => <div>{val ? val + (record.type * 1 === 2 ? '元/月' : '元') : '-'}</div>,
    },
    {
      title: t('租期'),
      dataIndex: 'duration',
      width: 50,
      align: 'center',
      fixed: true,
      render: val => <div>{val ? val + '月' : '-'}</div>,
    },
    {
      title: t('合计'),
      dataIndex: 'total_price',
      align: 'center',
      fixed: true,
      render: val => <div>{val}元</div>,
    },
    {
      title: t('数量'),
      dataIndex: 'number',
      width: 50,
      align: 'center',
      fixed: true,
      render: (val, record) => <div>
        <NumberInput size='small' min={1} max={val - record['deliver_number']} defaultValue={1}
                     onChange={v => store.number = v}/>
        <div style={{color: '#656565'}}>{t('剩余')} {val - record['deliver_number']} {t('台未发')}</div>
      </div>,
    },
    {
      title: t('项目编号'),
      dataIndex: 'extra_sn',
      align: 'center',
      fixed: true,
      render: val => <div>{val ? val : '-'}</div>,
    },
    {
      title: t('预计到货'),
      dataIndex: 'period',
      width: 70,
      align: 'center',
      fixed: true,
      render: val => <div>{val ? val : '-'}</div>,
    },
  ]

  const filterAddress = () => {
    const defAddress = addressStore.addresses.filter(v => v.is_default)
    if (defAddress.length) {
      store.addressId = defAddress[0].id
    }
  }


  const handleSubmit = () => {
    setLoading(true)
    store.postSend().then(() => {
      history.push('/user/order/submit')
    }).finally(() => {
      setLoading(false)
    })
  }

  const data = orders[orderIndex]
  return (
    <React.Fragment>
      <div className={styles.cart}>

        <div className={styles.listTitle}>
          <div className={['steps', styles.steps].join(" ")} data-class={'prev, cur'}>
            <div className="step cur">{t('选择货物和送货地址')}</div>
            <div className="step ">{t('提交订单')}</div>
          </div>

          <a onClick={() => {
            history.go(-1)
          }}>&lt;{t('返回订单列表')}</a>
        </div>

        <div className="mainBox-">

          <div className="paramSelect">
            <div className="h1"/>
          </div>

          <div className={styles.innerTitle}>
            <div>{t('订单编号')}：{data.sn}</div>
            <div style={{flex: 1, marginLeft: '38px'}}>{t('报价单总金额')}： <b
              style={{color: '#cc0000'}}>￥{data['total_price'].toFixed(2)}</b></div>
            <div>{t('报价时间')}： {data.created_at}</div>
          </div>
          <Table className={styles.table}
                 pagination={false}
                 rowKey={item => item.id + '-' + item.type}
                 dataSource={[goods]}
                 columns={columns}/>


          <div className="paramSelect">
            <div className="h2">
              <span>{t('收货信息')}</span>
              <a onClick={() => history.push('/user/address')}>{t('管理收货地址')}</a>
            </div>

            <div className="paramsList">

              <List
                style={{margin: '0 auto', width: '100%'}}
                dataSource={toJS(addressStore.addresses)}
                grid={{column: 3, gutter: 23}}
                loading={addressStore.isFetching}
                renderItem={item => (
                  <List.Item>
                    <div className={['item', item.id === addressId ? 'cur' : ''].join(" ")}
                         onClick={() => store.addressId = item.id}>
                      <div className="param">
                        <div className="label">{item.remark} </div>
                      </div>
                      <div className="param">
                        <div className="label">{t('地址')}：</div>
                        <div className="text">{item.province} {item.city} {item.area} {item.details}</div>
                      </div>
                      <div className="param">
                        <div className="label">{t('联系人')}：</div>
                        <div className="text">{item.name} {item.phone}</div>
                      </div>
                    </div>
                  </List.Item>
                )}/>

            </div>
          </div>

          <div className={['flex', styles.checkFt].join(" ")}>
            <div className={styles.msg}>
              <p>{t('备注')}</p>
              <TextArea
                onChange={v => store.remark = v}
                placeholder={t('不超过200字，非必填')}
                showCount={true}
                maxLength={200}
                autoSize={{minRows: 3, maxRows: 5}}
              />

            </div>
            <div className={styles.btnGroup}>
              <Button type="primary" size="large" onClick={() => {
                history.go(-1)
              }} ghost>{t('返回修改')}</Button>
              <Button type="primary" size="large" onClick={handleSubmit} loading={loading}>{t('确认提交')}</Button>
            </div>
          </div>
        </div>


      </div>

    </React.Fragment>
  )
})
